import { WSAlert } from "@wingspanhq/fe-component-library";
import {
  IPayerTaxFormResponse,
  TaxFormNeedsActionReason,
  TaxFormStatus
} from "@wingspanhq/payments/dist/interfaces";
import React from "react";

export const TaxFormValidationAlert: React.FC<{
  taxForm: IPayerTaxFormResponse;
  onEdit?: () => void;
}> = ({ taxForm, onEdit }) => {
  if (
    taxForm.status === TaxFormStatus.NeedsAction &&
    taxForm.needsActionReason === TaxFormNeedsActionReason.IncompleteW9 &&
    taxForm.validationErrors?.length
  ) {
    return (
      <WSAlert
        theme="warning"
        icon="alert"
        title="Validation failed"
        action={
          onEdit
            ? {
                text: "Edit contractor details",
                onClick: onEdit
              }
            : undefined
        }
      >
        <ul>
          {taxForm.validationErrors.map((error: any) => (
            <li>{error.message}</li>
          ))}
        </ul>
      </WSAlert>
    );
  }

  return null;
};
